"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const index_1 = require("./Header/index");
const Draggable_1 = require("./Draggable");
const index_2 = require("./Body/index");
const Inner_1 = require("./Inner");
const context_1 = require("./context");
const react_hanger_1 = require("react-hanger");
const reactstrap_1 = require("reactstrap");
const defaultState = {
    isEditing: false,
};
exports.ConversionStepCanvas = ({ data, data: { paused, type }, meta, meta: { fields }, position, position: { index }, onChange, onDestroy, moveDown, moveUp, }) => {
    const disableButtons = !!data.paused;
    const { state, setState } = react_hanger_1.useSetState(defaultState);
    react_1.useEffect(() => {
        if (paused && state.isEditing) {
            setState({
                isEditing: false,
            });
        }
    }, [paused]);
    return (react_1.default.createElement(Draggable_1.ConversionStepCanvasDraggable, { index: index }, (draggable, snapshot) => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(context_1.ConversionStepCanvasDataContext.Provider, { value: {
                data,
                draggable,
                info: {
                    disableButtons,
                    disablePauseButton: disableButtons && !data.paused,
                    hasEditPanel: !!(meta.fields && meta.fields.length > 0),
                },
                meta,
                position,
                snapshot,
                state,
            } },
            react_1.default.createElement(context_1.ConversionStepCanvasUpdateContext.Provider, { value: {
                    destroy: onDestroy,
                    moveDown,
                    moveUp,
                    pause: () => onChange({
                        paused: !paused,
                    }),
                    setState,
                    update: onChange,
                } },
                react_1.default.createElement(Inner_1.ConversionStepCanvasInner, { dragHandleProps: draggable.dragHandleProps, innerRef: draggable.innerRef, isDragging: snapshot.isDragging, draggableProps: draggable.draggableProps, isEditing: state.isEditing, setState: setState },
                    react_1.default.createElement(index_1.ConversionStepCanvasHeader, null),
                    react_1.default.createElement(reactstrap_1.Collapse, { isOpen: fields && fields.length > 0 && state.isEditing },
                        react_1.default.createElement(index_2.ConversionStepCanvasBody, { fields: fields, type: type }))),
                draggable.placeholder))))));
};
//# sourceMappingURL=index.js.map